module.exports = __webpack_public_path__ + "img/lc2@2x.fdfbcd3a.png";